import React from 'react';
import { Divider, Grid, Typography } from "@mui/material";

export default function Test() {

	return (
		<Grid item py={2} px={{ xs: 0, sm: 2, md: 4, lg: 20 }}>
			<Typography component="h1" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 36, md: 36, lg: 54 }, fontWeight: 600 }}>
				Titre
			</Typography>
			<Divider sx={{ backgroundColor: '#004afe', mb: 4, mt: 2, height: 3, width: 130 }} />

			<Typography component="h2" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 36, md: 36, lg: 46 }, fontWeight: 400 }}>
				Sous titre
			</Typography>
			<Divider sx={{ backgroundColor: '#004afe', mb: 4, mt: 2, height: 3, width: 130 }} />

			<Grid container>
				
			</Grid>
		</Grid>
	);
}